import { jsx as _jsx } from "react/jsx-runtime";
import { createRoot } from 'react-dom/client';
import App from './App';
const rootElement = document.getElementById('root');
if (!rootElement) {
    throw new Error('Root element with id "root" was not found.');
}
createRoot(rootElement).render(_jsx(App, {}));
